import React from 'react';
import _get from 'lodash/get';
import { Playlist } from 'web-media-ui-component';
import Analytics from 'utils/analytics';
import Tracking from 'utils/tracking';

const PlaylistWrapper = ({
    topicTitle,
    list,
    clipId,
    onItemClick,
    itemsBasePath,
    topic,
    sponsorshipAd,
    lang,
    dictionary,
}) => {

    /**
     * This @PlaylistKey represent the playlist order in the page.
     * So far, we only have one playlist, so we are going to hard-code this value.
     * Later on, if we have more than one list, we can build/use the index list's array
     * to get that key from.
     */
    const PLAYLIST_KEYS = {
        PLAYLIST_1: 0,
    };

    const onItemClickHandler = (slug, event, data, index) => {

        event.preventDefault();
        onItemClick(data, slug);
        Tracking.onPlaylistItemClick(index, PLAYLIST_KEYS.PLAYLIST_1, _get(event, 'currentTarget.href'));

    };

    const topicSlug = _get(topic, 'slug');

    return (
        <Playlist
            topicTitle={topicTitle}
            itemsBasePath={itemsBasePath}
            topicSlug={topicSlug}
            onItemClick={onItemClickHandler}
            list={list}
            currentPlayingClipId={clipId}
            sponsorshipAd={sponsorshipAd}
            lang={lang}
            dictionary={dictionary}
        />
    );

};

export default PlaylistWrapper;
